// =============================================================================
// Theme Plugin (SSR-compatible)
// =============================================================================
// Reads theme from cookie and applies data-preset attribute
// Works on both server and client for flash-free theme switching

import { type ThemePresetId, COOKIE_NAME, DEFAULT_PRESET, isValidPreset } from '~/theme/presets'

export default defineNuxtPlugin({
  name: 'theme',
  enforce: 'pre',
  setup() {
    // Read theme preset from cookie
    const presetCookie = useCookie<ThemePresetId>(COOKIE_NAME, {
      default: () => DEFAULT_PRESET,
    })

    // Validate preset value
    const preset = isValidPreset(presetCookie.value) ? presetCookie.value : DEFAULT_PRESET

    // Server-side: inject into head to prevent flash
    if (import.meta.server) {
      useHead({
        htmlAttrs: {
          'data-preset': preset,
        },
      })
    }

    // Client-side: apply immediately and watch for changes
    if (import.meta.client) {
      // Apply on initial load
      document.documentElement.setAttribute('data-preset', preset)

      // Watch for cookie changes and update DOM
      watch(presetCookie, (newPreset) => {
        if (isValidPreset(newPreset)) {
          document.documentElement.setAttribute('data-preset', newPreset)
        }
      })
    }
  },
})
